import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import FullPageError from './FullPageError';
import UILink from 'UIComponents/link/UILink';
import { jsx as _jsx } from "react/jsx-runtime";
export const EmptyStateError = () => /*#__PURE__*/_jsx(ErrorMessage, {
  "data-test-id": "network-error-other",
  illustration: "empty-state-charts",
  title: /*#__PURE__*/_jsx("h4", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payments.errorState.unavailable.title"
    })
  }),
  marginBlockStart: "1300",
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "payments.errorState.unavailable.text"
  })
});
const NetworkErrorPage = ({
  statusCode,
  sourceUrl
}) => {
  if (statusCode === 500) {
    return /*#__PURE__*/_jsx(FullPageError, {});
  } else if (statusCode === 410) {
    return /*#__PURE__*/_jsx(ErrorMessage, {
      illustration: "empty-state-charts",
      title: /*#__PURE__*/_jsx("h4", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "payments.errorState.expired.title"
        })
      }),
      children: /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "payments.errorState.expired.text_jsx",
          options: {
            href: sourceUrl
          },
          elements: {
            Link: UILink
          }
        })
      })
    });
  }
  return /*#__PURE__*/_jsx(EmptyStateError, {});
};
export default NetworkErrorPage;